import styled from 'styled-components'

type HiddenAriaFieldProps = {
  text: string
}

const Container = styled.div`
  position: absolute;
  width: 0.001rem;
  height: 0.001rem;
  white-space: nowrap;
  border: 0;
  font-size: 0.001rem;
`

// Define the HiddenAriaField component
export const HiddenAriaField: React.FC<HiddenAriaFieldProps> = ({ text }) => {
  return (
    <Container aria-live="polite" id="aria-field" tabIndex={-1}>
      {text}
    </Container>
  )
}
